import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import CompanyInfoForm from './blocks/CompanyInfoForm'
import { yupResolver } from '@hookform/resolvers/yup'
import OrderFormFooter from './blocks/OrderFormFooter'
import { Row } from 'antd'
import UserInformation from './blocks/UserInformation'
import { BusinessCardFormSchema } from '../../models/businessCardOrder.schema'
import {
  OrderBusinessCardType,
  useBusinessCardOrderDetailMutation,
} from '@app/store/reducers/salaryCards/businessCardOrder.api'

export default function UpdateEmployeeForm() {
  const [_, { data, isSuccess }] = useBusinessCardOrderDetailMutation({
    fixedCacheKey: 'businessCardOrderDetail',
  })

  const methods = useForm<OrderBusinessCardType>({
    mode: 'all',
    resolver: yupResolver(BusinessCardFormSchema),
  })

  const { setValue, trigger } = methods

  useEffect(() => {
    if (isSuccess) {
      setValue('cardCurrency', data?.cardCurrency, { shouldValidate: true })
      setValue('orderNo', data?.orderNo, { shouldValidate: true })
      setValue('accountBranch', data?.accountBranch, { shouldValidate: true })
      setValue('transferredBranch', data?.transferredBranch, { shouldValidate: true })
      setValue('cardAccount', data?.cardAccount, { shouldValidate: true })
      setValue('cardHolder', data?.cardHolder, { shouldValidate: true })
      setValue('commission', data?.commission, { shouldValidate: true })
      setValue('note', data?.note, { shouldValidate: true })
      setValue('trustedPerson', data?.trustedPerson, { shouldValidate: true })
      setValue('orderType', data?.orderType, { shouldValidate: true })
      setValue('orderDeliveryType', data?.orderDeliveryType, { shouldValidate: true })
      setValue('cardTariffId', data?.cardTariffId, { shouldValidate: true })

      trigger()
    }
  }, [isSuccess])

  return (
    <FormProvider {...methods}>
      <Row
        style={{ flexDirection: 'column', marginBottom: 30 }}
        gutter={[0, 24]}
      >
        <CompanyInfoForm />
      </Row>
      <UserInformation />
      <OrderFormFooter type="update" />
    </FormProvider>
  )
}
